import {
	connect
} from 'react-redux'
import SearchEpcComponent from '../components/SearchEpcComponent.jsx';
import {
	findSearchEpcList,
	findAllOrderIds,
	cleanSearchEpcAlert
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	allOrderIds: state.getIn(['fittingReducer', 'allOrderIds']),
	alertStyle: state.getIn(['searchReducer', 'alertStyle']),
	alertMessage: state.getIn(['searchReducer', 'alertMessage']),
})

const mapDispatchToProps = (dispatch) => ({
	searchEpc: (searchEpcInput) => {
		dispatch(findSearchEpcList({ searchEpcInput: searchEpcInput }));
	},
	searchLabelId: (searchLabelIdInput) => {
		dispatch(findSearchEpcList({ searchLabelIdInput: searchLabelIdInput }));
	},
	searchBagBarcode: (searchBagBarcodeInput) => {
		dispatch(findSearchEpcList({ searchBagBarcodeInput: searchBagBarcodeInput }));
	},
	searchOrdererName: (searchOrdererNameInput, searchOrderIdInput) => {
		dispatch(findSearchEpcList({ searchOrdererNameInput: searchOrdererNameInput, searchOrderIdInput: searchOrderIdInput }));
	},
	findAllOrderIds: () => {
		dispatch(findAllOrderIds());
	},
	cleanAlert: () => {
		dispatch(cleanSearchEpcAlert());
	}
})

const SearchEpcContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchEpcComponent)

export default SearchEpcContainer;


// WEBPACK FOOTER //
// ./src/containers/SearchEpcContainer.jsx